import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/home.css";
import BottomNav from "../components/BottomNav";
import Navbar from "../components/Navbar";
import FilterDrawer from "../components/FilterDrawer";
import { useCart } from "../contexts/CartContext";
import axios from "axios";
import { auth } from "../firebase";

const Shop = () => {

  const { addToCart } = useCart();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  // ✅ CATEGORY STATE
  const [categories, setCategories] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState("All");

  const [priceFilter, setPriceFilter] = useState("All");

  const [filterOpen, setFilterOpen] = useState(false);

  /* FETCH PRODUCTS */

  useEffect(() => {

    axios
      .get("https://ecommerce-backend-zxtw.onrender.com/api/products")
      .then((res) => {

        const data = res.data;

        setProducts(data);
        setFilteredProducts(data);

        // ✅ GET UNIQUE CATEGORIES
        const uniqueCategories = [
          ...new Set(data.map((p) => p.category))
        ];

        setCategories(uniqueCategories);

      })
      .catch((err) => console.log(err));

  }, []);

  /* FILTER LOGIC */

  useEffect(() => {

    let filtered = [...products];

    // ✅ CATEGORY FILTER
    if (categoryFilter !== "All") {
      filtered = filtered.filter(
        (product) =>
          product.category?.toLowerCase() === categoryFilter.toLowerCase()
      );
    }

    // ✅ PRICE FILTER
    if (priceFilter === "low") {
      filtered = filtered.filter((p) => p.price < 1000);
    }

    if (priceFilter === "mid") {
      filtered = filtered.filter(
        (p) => p.price >= 1000 && p.price <= 5000
      );
    }

    if (priceFilter === "high") {
      filtered = filtered.filter((p) => p.price > 5000);
    }

    setFilteredProducts(filtered);

  }, [categoryFilter, priceFilter, products]);

  return (

    <div className="shop-container">

      <Navbar />

      <h1 className="shop-title">
        {categoryFilter !== "All"
          ? `${categoryFilter} Products`
          : "Products"}
      </h1>

      {/* FILTER DRAWER */}

      <FilterDrawer
        isOpen={filterOpen}
        setIsOpen={setFilterOpen}
        categories={categories}
        categoryFilter={categoryFilter}
        setCategoryFilter={setCategoryFilter}
        priceFilter={priceFilter}
        setPriceFilter={setPriceFilter}
      />

      {/* PRODUCTS */}

      <div className="product-grid">

        {filteredProducts.length === 0 && (
          <p style={{ textAlign: "center", width: "100%" }}>
            No products found
          </p>
        )}

        {filteredProducts.map((product) => (

          <div
            className="product-card"
            key={product._id}
            onClick={() => navigate(`/product/${product._id}`)}
          >

            <img
              src={product.images?.[0]?.replace(
                "/upload/",
                "/upload/w_600,q_auto,f_auto/"
              )}
              alt={product.name}
              loading="lazy"
            />

            <h3>{product.name}</h3>

            <p>₹{product.price}</p>

            <button
              onClick={(e) => {
                e.stopPropagation();

                const user = auth.currentUser;

                if (!user) {
                  alert("Please login to add items to cart");
                  navigate("/login");
                  return;
                }

                addToCart(product);
                navigate("/cart");
              }}
            >
              Add to Cart
            </button>

          </div>

        ))}

      </div>

      <BottomNav />

    </div>

  );
};

export default Shop;